"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Device = function () {
  function Device(json) {
    this.id = json.id;
    this.isActive = json.is_active;
    this.isPrivateSession = json.is_private_session;
    this.isRestricted = json.is_restricted;
    this.name = json.name;
    this.type = json.type;
    this.volumePercent = json.volume_percent;
  }

  return Device;
}();

exports.default = Device;